import useScrollReveal from '@/hooks/useScrollReveal';
import { useCommunity } from '@/context/CommunityContext';

/**
 * Canonical blue Discord community banner — the shared cross-site banner
 * (blue Discord treatment with a subtle red accent) used identically on the
 * hub, KF1 and Minecraft sites. Invite href comes from shared community data.
 */
export default function DiscordCtaSection() {
  const sectionRef = useScrollReveal();
  const { discordInvite } = useCommunity();

  return (
    <section ref={sectionRef} className="relative z-10 pb-20">
      <div className="container mx-auto px-4">
        {/* Discord Community Banner */}
        <div className="scroll-reveal">
          <div className="relative overflow-hidden rounded-lg border border-red-900/30 bg-gradient-to-r from-[#5865F2]/20 via-black/60 to-red-900/20 p-8 md:p-12">
            <div className="absolute inset-0 bg-gradient-to-r from-[#5865F2]/10 to-red-600/10 opacity-50"></div>
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 bg-[#5865F2] rounded-2xl flex items-center justify-center shadow-lg shadow-[#5865F2]/30 flex-shrink-0">
                  <i className="ri-discord-fill text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white font-orbitron mb-1">
                    Join Our Community
                  </h3>
                  <p className="text-gray-300 text-lg">
                    Chat with players, get server updates, find teammates, and connect with admins
                  </p>
                </div>
              </div>
              <a
                href={discordInvite}
                target="_blank"
                rel="noopener noreferrer"
                className="pulse-glow flex items-center gap-3 bg-[#5865F2] hover:bg-[#4752C4] text-white px-8 py-4 rounded-lg text-lg font-bold transition-colors whitespace-nowrap shadow-lg shadow-[#5865F2]/25"
              >
                <i className="ri-discord-fill text-xl"></i>
                Join Discord
              </a>
            </div>
            <div className="relative z-10 mt-6 flex flex-wrap gap-6 justify-center md:justify-start text-sm text-gray-400">
              <span className="flex items-center gap-2"><i className="ri-group-line text-[#5865F2]"></i> Active Community</span>
              <span className="flex items-center gap-2"><i className="ri-notification-3-line text-[#5865F2]"></i> Server Announcements</span>
              <span className="flex items-center gap-2"><i className="ri-customer-service-2-line text-[#5865F2]"></i> Admin Support</span>
              <span className="flex items-center gap-2"><i className="ri-calendar-event-line text-[#5865F2]"></i> Event Updates</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
